module.exports = require("marked");


//////////////////
// WEBPACK FOOTER
// external "marked"
// module id = 92
// module chunks = 0